/// <amd-module name="Search/Shared/Components/SearchOverlay/index" />
export * from "./SearchOverlay";
export * from "./SearchOverlay.Props";
